export default {
	//用于路由权限
	allRoute:[
		'/customers',
		'/customers/customer',
		'/basicSets',
		'/basicSets/company',
		'/basicSets/operator',
		'/basicSets/salesman',
		'/basicSets/rolePermission',
		'/basicSets/VIParameterConfig',
		'/products',
		'/products/info',
		'/products/classify',
		'/products/brand',
		'/products/unit',
		'/warehouse',
		'/warehouse/storehouse',
		'/warehouse/location',
		'/outAndIn',
		'/outAndIn/disassembly',
		'/outAndIn/assemble',
		'/outAndIn/stockIn',
		'/outAndIn/stockOut',
		'/outAndIn/inventory',
		'/erp',
		'/erp/waitForStockIn',
		'/erp/waitForStockOut',
		'/erp/waitForDisassembly',
		'/erp/waitForAssemble',
		'/erp/erpBill',
		'/systemParam',
		'/systemParam/stockType',
		'/systemParam/systemMenu',
		'/systemParam/systemLog',
		'/systemParam/erpBillType',
		'/openService',
		'/openService/appAdmin',
		'/openService/systemModel',
		'/openService/interface',
		'/openService/serviceStyle',
	],
	//用于表格配置
	apiOption:{
		stockIn: "/admin/receipt/sn/list",
		stockOut: "/admin/issue/sn/list",
		inventoryGoods: "",
		storehouse: "/admin/warehouse/list",
		location: "/admin/warehouse/location/list",
		info: "/admin/goods/list",
		classify: "",
		brand: "/goods/brand/list",
		unit: "/admin/goods/units/list",
		company: "/admin/company/list",
		operator: "/admin/user/list",
		salesman: "/admin/salesman/list",
		rolePermission: "/admin/sort/list",
		customer: "/admin/customer/list",
		systemLog: "/admin/log/list",
		stockType: "/admin/inouttype/list",
		interface: "/admin/service/open/list",
		systemModel:  "/admin/service/model/list",
		appAdmin: "/admin/open/app/list",
		serviceStyle: "/admin/service/style/list",
		erpBillType: "/admin/erp/order/type/list",
		erpBill: "/admin/erp/order/list",
	},
	//用于表格列显示自定义列
	tableConfig:{
		stockIn: [
			{ slot: 'action', position:"right" },
			{ slot: 'serial_number' },
		],
		stockOut: [
			{ slot: 'action', position:"right"},
			{ slot: 'serial_number' },
		],
		inventoryGoods: [],
		storehouse: [
			{ slot: 'action', position:"right" },
		],
		location: [
			{ slot: 'action', position:"right" },
		],
		info: [
			{ slot: 'action', position:"right" },
		],
		classify: [
			{ key: 'goods_type_name', name: '分类名称' },
			{ slot: 'action', position:"right" },
		],
		brand: [
			{ slot: 'action', position:"right" },
		],
		unit: [
			{ slot: 'action', position:"right" },
		],
		company: [
			{ slot: 'company_name', position:"left" },
			{ slot: 'logo', width: 120 },
			{ slot: 'action', position:"right" },
		],
		operator: [
			{ slot: 'login_name', width: 120 },
			{ slot: 'logo', width: 120 },
			{ slot: 'action', position:"right" },
		],
		salesman: [
			{ slot: 'action', position:"right" },
		],
		rolePermission: [
			{ slot: 'sort_value', width: 120 },
			{ slot: 'action', position:"right" },
		],
		customer: [
			{ slot: 'action', position:"right"},
		],
		systemLog: [
			{ selection: 'selection', fixed:"left", position:"left" },
			{ slot: 'action', position:"right"},
		],
		systemMenu: [
			{ key: 'menu_name', name: '菜单名称' },
			{ slot: 'menu_icon'},
			{ slot: 'menu_type'},
			{ slot: 'is_system'},
			{ key: 'api_name', name: '接口地址' },
			{ key: 'menu_route', name: '路由地址' },
			{ slot: 'action', position:"right" },
		],
		stockType: [ 
			{ slot: 'action', position:"right"},
		],
		interface: [
			{ slot: 'action', position:"right"},
		],
		appAdmin: [
			{ slot: 'allow_ip',},
			{ slot: 'action', position:"right"},
		],
		systemModel: [
			{ slot: 'action', position:"right"},
		],
		serviceStyle: [
			{ slot: 'action', position:"right"},
		],
		erpBill: [
			{ slot: 'action', position:"right"},
		],
		erpBillType: [
			{ slot: 'action', position:"right"},
		],
	}
};